export const StateScreen = {
  stInsert: 'INSER',
  stUpdate: 'UPDATE',
  stView: 'VIEW',
  stSearch: 'SEARCH',
};
